import { DoricSuperNode, DoricViewNode } from "./DoricViewNode";
export class DoricRefreshableNode extends DoricSuperNode {
    constructor() {
        super(...arguments);
        this.headerViewId = "";
        this.contentViewId = "";
        this.refreshable = true;
    }
    build() {
        const ret = document.createElement('div');
        ret.style.overflow = "hidden";
        const header = document.createElement('div');
        const content = document.createElement('div');
        header.style.width = "100%";
        header.style.height = "100%";
        header.style.display = "flex";
        header.style.alignItems = "flex-end";
        header.style.justifyContent = "center";
        content.style.width = "100%";
        content.style.height = "100%";
        ret.appendChild(header);
        ret.appendChild(content);
        let touchStart = 0;
        ret.ontouchstart = (ev) => {
            if (!this.refreshable) {
                return;
            }
            touchStart = ev.touches[0].pageY;
        };
        ret.ontouchmove = (ev) => {
            var _a;
            if (!this.refreshable) {
                return;
            }
            const offset = (ev.touches[0].pageY - touchStart) * 0.68;
            ret.scrollTop = Math.max(0, header.offsetHeight - offset);
            (_a = this.headerNode) === null || _a === void 0 ? void 0 : _a.callJSResponse("setPullingDistance", offset);
        };
        const touchend = () => {
            var _a, _b;
            if (!this.refreshable) {
                return;
            }
            if (header.offsetHeight - ret.scrollTop >= (((_a = this.headerNode) === null || _a === void 0 ? void 0 : _a.getWidth()) || 0)) {
                this.setRefreshing(true);
                (_b = this.onRefreshCallback) === null || _b === void 0 ? void 0 : _b.call(this);
            }
            else {
                // To idel
                ret.scrollTo({
                    top: header.offsetHeight,
                    behavior: "smooth"
                });
            }
        };
        ret.ontouchcancel = () => {
            touchend();
        };
        ret.ontouchend = () => {
            touchend();
        };
        window.requestAnimationFrame(() => {
            ret.scrollTop = header.offsetHeight;
        });
        this.headerContainer = header;
        this.contentContainer = content;
        return ret;
    }
    blendProps(v, propName, prop) {
        if (propName === 'content') {
            this.contentViewId = prop;
        }
        else if (propName === 'header') {
            this.headerViewId = prop;
        }
        else if (propName === 'onRefresh') {
            this.onRefreshCallback = () => {
                this.callJSResponse(prop);
            };
        }
        else {
            super.blendProps(v, propName, prop);
        }
    }
    blendSubNode(model) {
        var _a;
        (_a = this.getSubNodeById(model.id)) === null || _a === void 0 ? void 0 : _a.blend(model.props);
    }
    getSubNodeById(viewId) {
        if (viewId === this.headerViewId) {
            return this.headerNode;
        }
        else if (viewId === this.contentViewId) {
            return this.contentNode;
        }
        return undefined;
    }
    onBlending() {
        var _a, _b, _c, _d, _e, _f;
        super.onBlending();
        {
            const headerModel = this.getSubModel(this.headerViewId);
            if (headerModel) {
                if (this.headerNode) {
                    if (this.headerNode.viewId !== this.headerViewId) {
                        if (this.reusable && this.headerNode.viewType === headerModel.type) {
                            this.headerNode.viewId = headerModel.id;
                            this.headerNode.blend(headerModel.props);
                        }
                        else {
                            (_a = this.headerContainer) === null || _a === void 0 ? void 0 : _a.removeChild(this.headerNode.view);
                            const headerNode = DoricViewNode.create(this.context, headerModel.type);
                            if (headerNode) {
                                headerNode.viewId = headerModel.id;
                                headerNode.init(this);
                                headerNode.blend(headerModel.props);
                                (_b = this.headerContainer) === null || _b === void 0 ? void 0 : _b.appendChild(headerNode.view);
                                this.headerNode = headerNode;
                            }
                        }
                    }
                }
                else {
                    const headerNode = DoricViewNode.create(this.context, headerModel.type);
                    if (headerNode) {
                        headerNode.viewId = headerModel.id;
                        headerNode.init(this);
                        headerNode.blend(headerModel.props);
                        (_c = this.headerContainer) === null || _c === void 0 ? void 0 : _c.appendChild(headerNode.view);
                        this.headerNode = headerNode;
                    }
                }
            }
        }
        {
            const contentModel = this.getSubModel(this.contentViewId);
            if (contentModel) {
                if (this.contentNode) {
                    if (this.contentNode.viewId !== this.contentViewId) {
                        if (this.reusable && this.contentNode.viewType === contentModel.type) {
                            this.contentNode.viewId = contentModel.id;
                            this.contentNode.blend(contentModel.props);
                        }
                        else {
                            (_d = this.contentContainer) === null || _d === void 0 ? void 0 : _d.removeChild(this.contentNode.view);
                            const contentNode = DoricViewNode.create(this.context, contentModel.type);
                            if (contentNode) {
                                contentNode.viewId = contentModel.id;
                                contentNode.init(this);
                                contentNode.blend(contentModel.props);
                                (_e = this.contentContainer) === null || _e === void 0 ? void 0 : _e.appendChild(contentNode.view);
                                this.contentNode = contentNode;
                            }
                        }
                    }
                }
                else {
                    const contentNode = DoricViewNode.create(this.context, contentModel.type);
                    if (contentNode) {
                        contentNode.viewId = contentModel.id;
                        contentNode.init(this);
                        contentNode.blend(contentModel.props);
                        (_f = this.contentContainer) === null || _f === void 0 ? void 0 : _f.appendChild(contentNode.view);
                        this.contentNode = contentNode;
                    }
                }
            }
        }
    }
    onBlended() {
        super.onBlended();
    }
    setRefreshing(v) {
        var _a;
        if (!this.headerContainer || !this.headerNode) {
            return;
        }
        if (v) {
            this.view.scrollTo({
                top: this.headerContainer.offsetHeight - this.headerNode.getHeight(),
                behavior: "smooth"
            });
            this.headerNode.callJSResponse("startAnimation");
        }
        else {
            this.view.scrollTo({
                top: (_a = this.headerContainer) === null || _a === void 0 ? void 0 : _a.offsetHeight,
                behavior: "smooth"
            });
            this.headerNode.callJSResponse("stopAnimation");
        }
    }
    setRefreshable(v) {
        this.refreshable = v;
        if (!v) {
            this.setRefreshing(false);
        }
    }
}
//# sourceMappingURL=DoricRefreshableNode.js.map